import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import { AUTH_NAMESPACE } from './modules/auth.types';

import app from './modules/app';
import { APP_NAMESPACE } from './modules/app.types';

import locations from './modules/locations';
import { LOCATIONS_NAMESPACE } from './modules/locations.types';

import enums from './modules/enums';
import { ENUMS_NAMESPACE } from './modules/enums.types';

import settings from './modules/settings';
import { APP_SETTINGS_NAMESPACE, ActionTypes as AppSettingsActionTypes } from './modules/settings.types';

Vue.use(Vuex);

const modules = {
  [AUTH_NAMESPACE]: auth,
  [APP_NAMESPACE]: app,
  [LOCATIONS_NAMESPACE]: locations,
  [ENUMS_NAMESPACE]: enums,
  [APP_SETTINGS_NAMESPACE]: settings,
};

// Automatic registration of store modules from @modules
const requireModule = require.context('@modules/', true, /\/store$/);
requireModule.keys().forEach((key) => {
  let moduleName;
  if (requireModule(key).namespace) {
    moduleName = requireModule(key).namespace;
  } else {
    const modulePath = key.match(/(?=\/)(.*)(?=\/store)/)[0].split('/');
    moduleName = modulePath[modulePath.length - 1];
  }
  modules[moduleName] = requireModule(key).default || requireModule(key);
});

export { LOCATIONS_NAMESPACE as APP_LOCATIONS_NAMESPACE };

export { APP_SETTINGS_NAMESPACE, AppSettingsActionTypes };

export default new Vuex.Store({ modules });
